import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './AboutStorySection.scss';

import storyImage from '../../../../assets/images/about/story-image.webp';

const AboutStorySection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const slideRight = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, x: 20 },
              whileInView: { opacity: 1, x: 0 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.1, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="about-story">
            <div className="about-story__container">
                <div className="about-story__grid">

                    <div className="about-story__content">
                        <motion.h2 className="about-story__title" {...fadeUp(0, 1.1)}>{t('our_story')}</motion.h2>
                        <motion.p className="about-story__text" {...fadeUp(0.15)}>
                            {t('story_text_1')}
                        </motion.p>
                        <motion.p className="about-story__text" {...fadeUp(0.3)}>
                            {t('story_text_2')}
                        </motion.p>
                    </div>

                    <div className="about-story__image-col">
                        <motion.img
                            {...slideRight}
                            src={storyImage}
                            alt={t('alt_our_church_community')}
                            className="about-story__image"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutStorySection;